export default __webpack_public_path__ + "static/media/suggestion-chips-watson-dialog2.ae1a9dd5.png";